module.exports = __webpack_public_path__ + "img/loaderV3_darkMode_1.c290a5a8.gif";